import { render, staticRenderFns } from "./mp_page.vue?vue&type=template&id=4e71ba37&"
import script from "./mp_page.vue?vue&type=script&lang=js&"
export * from "./mp_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports